var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"FormTopicScaffold"},[_c('Field',{attrs:{"label":_vm.$t('textarea'),"required":"","type":"textarea","value":_vm.blueprintsJson},on:{"update:value":_vm.setBlueprints}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }